module.exports = __webpack_public_path__ + "img/kuspit-logo.06e1975a.svg";